export default "__VITE_ASSET__DCDIUd1z__"